import goalSiteImage from '../assets/images/goalSite.png';
import restaurantReservation from '../assets/images/restaurantReservation.png';

export const projects = [
    {
        title: "Goal Tracker",
        subtitle: "Track your goals",
        description:
            "Fullstack MERN application utilizing authentication, also leveraging Redux for state management.",
        image: goalSiteImage,
        link: "https://goals-frontend-y32p.onrender.com",
        source: "https://github.com/kelvin711/Goals"

    },
    {
        title: "Restaurant Reservation System",
        subtitle: "Reservation System with full CRUD",
        description:
            "A full-stack restaurant reservation system utilizing PostgreSQL, React, and Node.js typically involves building a comprehensive application that allows users to book, manage, and organize restaurant reservations.",
        image: restaurantReservation,
        link: "https://starter-restaurant-reservation-1-3kf1.onrender.com/dashboard",
        source: "https://github.com/kelvin711/starter-restaurant-reservation"

    }
];

export const skills = [
    "JavaScript",
    "Python",
    "Java",
    "HTML",
    "Django",
    "React",
    "Flask",
    "Spring",
    "MySQL",
    "MongoDB",
    "Git",
    "Github",
    "Tailwind CSS",
    "Boot-Strap",
];

